import { Grid, IconButton, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useStoreContext } from "../..";
import dayjs from "dayjs";
import EditIcon from "@mui/icons-material/Edit";

const SymptomDayList = observer(
  ({ onClick }: { onClick: (entry: any) => void }) => {
    const { measurementStore, fieldStore } = useStoreContext();

    if (!measurementStore.daySymptoms || !fieldStore.mappedSymptomNames) {
      return null;
    }

    const days = Array.from(measurementStore.daySymptoms.keys());
    const getDailySymptoms = (date: string) => {
      const symptoms = measurementStore.daySymptoms?.get(date);
      if (!symptoms) {
        return "";
      }
      return symptoms
        .map((s) => fieldStore.mappedSymptomNames?.get(s))
        .join(", ");
    };

    return (
      <>
        {days.map((item, index) => (
          <Grid
            container
            key={index}
            p={2}
            sx={{ borderBottom: "1px solid lightgrey" }}
            spacing={2}
          >
            <Grid item xs={12} sm={3}>
              <Typography>{`${dayjs(item).format("YYYY-MM-DD")} (v${dayjs(
                item
              ).isoWeek()})`}</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography>{getDailySymptoms(item)}</Typography>
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={() => onClick(dayjs(item))}>
                <EditIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </>
    );
  }
);

export default SymptomDayList;
